import { ColDef } from "ag-grid-community";
import { Info } from "./GridFrameworks";

export const columnDef: ColDef[] = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 65,
        minWidth: 65,
        pinned: "left",
    },
    {
        headerName: "Role Identifier",
        field: "Id",
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: "Role Name",
        field: "Name",
        flex: 1,
        minWidth: 200,
    },
    {
        headerName: "Description",
        field: "Description",
        flex: 2,
        minWidth: 300,
    },
];
